import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface MessageCatalogItem {
  id: number;
  category: string; // CHANNEL | TYPE
  itemKey: string;
  name: string;
  description?: string | null;
  howItWorks?: string | null;
  displayOrder: number;
}

function mapItem(x: any): MessageCatalogItem {
  return {
    id: x.id ?? x.Id,
    category: x.category ?? x.Category ?? '',
    itemKey: x.itemKey ?? x.ItemKey ?? '',
    name: x.name ?? x.Name ?? '',
    description: x.description ?? x.Description ?? '',
    howItWorks: x.howItWorks ?? x.HowItWorks ?? '',
    displayOrder: x.displayOrder ?? x.DisplayOrder ?? 0,
  };
}

function mapEnvelope(res: any) {
  if (Array.isArray(res?.data)) return { ...res, data: res.data.map(mapItem) };
  if (Array.isArray(res)) return res.map(mapItem);
  return res;
}

@Injectable({ providedIn: 'root' })
export class MessageCatalogService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/MessageCatalog`;

  getAll() {
    return this.http.get(`${this.baseUrl}/GetAll`).pipe(map(mapEnvelope));
  }
}
